module.exports = __webpack_public_path__ + "img/insta.cfa0ec98.png";